<template>
  <!-- Page Header -->
  <div class="page-header">
    <div class="page-title">
      <h4>{{ title }}</h4>
    </div>
    <div class="page-btn" v-if="isBanRoute">
      <ul>
        <li>
          <a
            href="javascript:;"
            class="btn btn-added center-flex"
            data-bs-toggle="modal"
            data-bs-target="#ban-address"
          >
            <i class="bx bx-plus-circle me-1"></i>{{ text }}</a
          >
        </li>
      </ul>
    </div>
    <div class="page-btn" v-if="isLanRoute">
      <ul>
        <li>
          <a
            href="javascript:;"
            class="btn btn-added center-flex"
            data-bs-toggle="modal"
            data-bs-target="#add-transaction"
          >
            <i class="bx bx-plus-circle me-1"></i>{{ text }}</a
          >
        </li>
      </ul>
    </div>
  </div>
  <!-- /Page Header -->
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
  },
  computed: {
    isBanRoute() {
      return this.$route.path === "/ban-address";
    },
    isLanRoute() {
      return (
        this.$route.path === "/language" ||
        this.$route.path === "/language-translate" ||
        this.$route.path === "/language-app" ||
        this.$route.path === "/language-admin"
      );
    },
  },
};
</script>
